<template>
  <!-- Export callers keep their local loading overlay (z-index 100000) active while awaiting the picker. -->
  <a-modal :visible="true" title="Ảnh trong phiếu thu thập TSSS" :width="800"
    :z-index="100001" :mask-closable="false" @cancel="$emit('cancel')">
    <p class="report-image-help">Chọn ảnh cho lần xuất này. Bỏ chọn tất cả để xuất phiếu không kèm ảnh.</p>
    <div class="report-image-groups">
      <section v-for="asset in assets" :key="asset.id" class="report-image-group">
        <div class="report-image-heading">
          <strong>TSSS_{{ asset.id }} · {{ selection[asset.id].length }}/{{ asset.images.length }} ảnh</strong>
          <a-checkbox :checked="asset.images.length > 0 && selection[asset.id].length === asset.images.length"
            :indeterminate="selection[asset.id].length > 0 && selection[asset.id].length < asset.images.length"
            :disabled="asset.images.length === 0" @change="toggleAll(asset, $event.target.checked)">Chọn tất cả</a-checkbox>
        </div>
        <p class="report-image-address">{{ asset.address }}</p>
        <p v-if="!asset.images.length">Tài sản chưa có hình ảnh.</p>
        <div v-else class="report-image-grid">
          <label v-for="(image, index) in asset.images" :key="image.key"
            class="report-image-card" :class="{ selected: selection[asset.id].includes(image.key) }">
            <img :src="image.url" :alt="'Ảnh ' + (index + 1) + ' — TSSS_' + asset.id" loading="lazy" @error="imageError" />
            <span class="report-image-caption">
              <input v-model="selection[asset.id]" type="checkbox" :value="image.key" />
              <span>Ảnh {{ index + 1 }} · {{ image.label }}</span>
            </span>
          </label>
        </div>
      </section>
    </div>
    <template slot="footer">
      <a-button @click="$emit('cancel')">Hủy</a-button>
      <a-button @click="withoutImages">Xuất không kèm ảnh</a-button>
      <a-button type="primary" @click="$emit('confirm', selection)">Xuất phiếu ({{ count }} ảnh)</a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  props: { assets: { type: Array, required: true } },
  data() {
    return { selection: Object.fromEntries(this.assets.map(asset => [asset.id, asset.images.map(image => image.key)])) };
  },
  computed: {
    count() { return Object.values(this.selection).reduce((total, keys) => total + keys.length, 0); }
  },
  methods: {
    toggleAll(asset, checked) { this.$set(this.selection, asset.id, checked ? asset.images.map(image => image.key) : []); },
    withoutImages() { this.$emit('confirm', Object.fromEntries(this.assets.map(asset => [asset.id, []]))); },
    imageError(event) { event.target.alt = 'Không tải được ảnh xem trước'; }
  }
};
</script>

<style scoped>
.report-image-help, .report-image-address { color: #657281; }
.report-image-groups { max-height: 60vh; overflow-y: auto; }
.report-image-group + .report-image-group { border-top: 1px solid #e3e8ed; margin-top: 20px; padding-top: 20px; }
.report-image-heading { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.report-image-address { margin: 6px 0 12px; }
.report-image-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
.report-image-card { border: 2px solid #e3e8ed; border-radius: 4px; overflow: hidden; cursor: pointer; margin: 0; }
.report-image-card.selected { border-color: #0089bd; }
.report-image-card:focus-within { outline: 2px solid #0089bd; outline-offset: 2px; }
.report-image-card img { width: 100%; height: 130px; object-fit: contain; background: #f4f6f8; }
.report-image-caption { display: flex; gap: 8px; padding: 8px; align-items: baseline; overflow-wrap: anywhere; }
@media (max-width: 600px) { .report-image-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } .report-image-heading { align-items: flex-start; flex-direction: column; } }
</style>
